import { HttpAction } from "@megaron/http-service";
import { Serializers, SerializerValue } from "@megaron/serializers";

export const blikCheckStatuses = [
  "pending",

  "outstanding", // 0
  "cashed", // 1
  "cancelled", // 2
  "expired", // 3
  "blocked", // 4
  "bankRejected", // 5
  "pspRejected", // 6
  "processing", // 7
] as const;
export type BlikCheckStatus = (typeof blikCheckStatuses)[number];
export const BlikCheckStatus = (str: string): BlikCheckStatus => {
  if (!blikCheckStatuses.includes(str as BlikCheckStatus)) throw new Error(`Invalid blik check status: ${str}`);
  return str as BlikCheckStatus;
};

export const blikCheckCommonFields = {
  id: Serializers.string,
  userId: Serializers.string,
  amount: Serializers.decimal,
  holdAmount: Serializers.decimal,
  status: Serializers.oneOf(...blikCheckStatuses),
  createdAt: Serializers.datetime,
  refreshAfter: Serializers.datetime.nullable(),
  withdrawnAt: Serializers.datetime.nullable(),
  withdrawalAmount: Serializers.decimal.nullable(),
};

export const blikCheckSerializer = Serializers.object({
  ...blikCheckCommonFields,
  phoneNumber: Serializers.string,
  santanderWithdrawalId: Serializers.string.nullable(),
  messageId: Serializers.string,
  refreshedAt: Serializers.datetime.nullable(),
});
export type BlikCheck = SerializerValue<typeof blikCheckSerializer>;

export const myBlikCheckSerializer = Serializers.object({
  ...blikCheckCommonFields,

  password: Serializers.string,
});
export type MyBlikCheck = SerializerValue<typeof myBlikCheckSerializer>;

export const blikCheckFiltersSerializer = Serializers.object({
  userId: Serializers.string.array().asJsonString(),
  checkId: Serializers.string.array().asJsonString(),
  status: Serializers.oneOf(...blikCheckStatuses)
    .array()
    .asJsonString(),
  limit: Serializers.integer,
  offset: Serializers.integer,
}).partial();
export type BlikCheckFilters = SerializerValue<typeof blikCheckFiltersSerializer>;

export const blikCheckActions = {
  myBlikChecksQuery: HttpAction({
    path: "/blikChecks/myChecks",
    method: "get",
    valueSerializer: Serializers.paginatedList(myBlikCheckSerializer),
    requiresAuth: true as const,
    qsSerializer: blikCheckFiltersSerializer,
  }),
  blikChecksQuery: HttpAction({
    path: "/blikChecks",
    method: "get",
    valueSerializer: Serializers.paginatedList(blikCheckSerializer),
    requiresAuth: true as const,
    qsSerializer: blikCheckFiltersSerializer,
  }),
  requestNewBlikCheck: HttpAction({
    path: "/blikChecks/new",
    method: "post",
    bodySerializer: Serializers.object({
      ...Serializers.object({
        userId: Serializers.string,
      }).partial().fields,
      amount: Serializers.decimal,
    }),
    requiresAuth: true as const,
    errorSerializer: Serializers.stringOneOf("InsufficientBalance", "InvalidAmount", "UnknownUserId"),
    valueSerializer: Serializers.object({
      checkId: Serializers.string,
    }),
  }),
  requestBlikCheckCancellation: HttpAction({
    path: "/blikChecks/requestCancellation",
    method: "post",
    requiresAuth: true as const,
    bodySerializer: Serializers.object({
      checkId: Serializers.string,
    }),
    errorSerializer: Serializers.stringOneOf("NotFound", "NotCancellable", "CancellationRequestFailed"),
  }),
};
